import ContentLoader from "react-content-loader";

const Skeleton = ({ type }) => {
  if (type === "bg") {
    return (
      <ContentLoader
        rtl
        speed={2}
        width={260}
        height={20}
        viewBox="0 0 260 20"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="1" ry="1" width="260" height="20" />
      </ContentLoader>
    );
  } else if (type === "round") {
    return (
      <ContentLoader
        rtl
        speed={2}
        width={256}
        height={20}
        viewBox="0 0 256 20"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="10" ry="10" width="256" height="20" />
      </ContentLoader>
    );
  } else {
    return (
      <ContentLoader
        rtl
        speed={2}
        width={80}
        height={20}
        viewBox="0 0 80 20"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="1" ry="1" width="80" height="20" />
      </ContentLoader>
    );
  }
};
export default Skeleton;
